import {Injectable} from '@angular/core';
import {ISearchParams} from '../state/products.state';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {UrlParamBuilderService} from './url-param-builder.service';
import {Sort} from '../../snatch/models/sort.model';
import {IPageable} from 'src/app/snatch/models/page.model';

@Injectable()
export class UrlStorageService {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private urlParamBuilderService: UrlParamBuilderService
  ) {}

  save(filters: ISearchParams = {}, sort: Sort = {}, pageable?: IPageable) {
    let params = this.urlParamBuilderService.constructParams(filters, sort, pageable);
    // Skip page && limit if same as defaults
    if (pageable) {
      if (pageable.page === this.urlParamBuilderService.DEFAULT_PAGE) {
        params = params.delete('page');
      }
      if (pageable.limit === this.urlParamBuilderService.DEFAULT_LIMIT) {
        params = params.delete('limit');
      }
    }
    const paramsToPersist = {};
    params.keys().forEach(p => (paramsToPersist[p] = params.getAll(p)));
    const yOffset = window.scrollY;
    let queryParamMap: any = this.route.snapshot.queryParamMap;

    this.router
      .navigate([], { relativeTo: this.route, queryParams: {...paramsToPersist}, replaceUrl: true })
      .then(() => window.scrollTo(0, yOffset));
  }

  restore(): { filters: ISearchParams; sort: Sort; pageable: IPageable } {
    const lastParams = new TypedParamMap<ISearchParams & IPageable>(this.route.snapshot.queryParamMap);
    const pageable = {
      page: parseInt(lastParams.get('page'), 10) || this.urlParamBuilderService.DEFAULT_PAGE,
      limit: parseInt(lastParams.get('limit'), 10) || this.urlParamBuilderService.DEFAULT_LIMIT
    };

    const filters: ISearchParams = {
      deliveryFormats: lastParams.getAll('deliveryFormats'),
      productTypes: lastParams.getAll('productTypes'),
      languages: lastParams.getAll('languages'),
      sellers: lastParams.getAll('sellers'),
      level: lastParams.getAll('level'),
      category: lastParams.getAll('category'),
      filter: lastParams.get('filter'),
      topic: lastParams.get('topic'),
      subtopic: lastParams.get('subtopic'),
      courseDeliveryFormats:lastParams.getAll('courseDeliveryFormats'),
      catalogs: lastParams.getAll('catalogs')
    };

    let sort: Sort = {};
    const sortParamKey = lastParams.paramMap.keys.find(k => k.startsWith('$'));
    if (sortParamKey) {
      sort = { key: sortParamKey.substr(1), order: parseInt(lastParams.paramMap.get(sortParamKey), 10) };
    }

    return { filters, sort, pageable };
  }
}

export class TypedParamMap<T> {
  constructor(public readonly paramMap: ParamMap) {}

  get(name: keyof T): string {
    return this.paramMap.get(name as string);
  }

  getAll(name: keyof T): string[] {
    return this.paramMap.getAll(name as string);
  }
}
